<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M17 12C17 14.7614 14.7614 17 12 17C11.0971 17 10.25 16.7607 9.51888 16.342L8.52643 18.0787C9.55005 18.6649 10.7359 19 12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12H3L6 15L9 12H7C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12Z"
  />
</template>
